import { z } from "zod";

import { zFoldFeatures, zHoleFeatures, zSideFeatures } from "../contracts/pycad/zod.gen";
import type { FoldFeatures, HoleFeatures, SideFeatures } from "../contracts/pycad/types.gen";

type GeneratedVisibleFeatureType = NonNullable<
  HoleFeatures["type"] | FoldFeatures["type"] | SideFeatures["type"]
>;

export const visibleFeatureTypes = [
  zHoleFeatures.shape.type.removeDefault().unwrap().value,
  zFoldFeatures.shape.type.removeDefault().unwrap().value,
  zSideFeatures.shape.type.removeDefault().unwrap().value,
] as const satisfies readonly GeneratedVisibleFeatureType[];

export type VisibleFeatureType = (typeof visibleFeatureTypes)[number];

export const circularHoleFeatureSchema = z.object({
  type: z.literal("Hole") satisfies z.ZodType<VisibleFeatureType>,
  subType: z.literal("hole_circular"),
  count: z.number(),
  diameter: z.number(),
});

export const slottedHoleFeatureSchema = z.object({
  type: z.literal("Hole") satisfies z.ZodType<VisibleFeatureType>,
  subType: z.literal("hole_slotted"),
  count: z.number(),
  diameter: z.number(),
});

export const complexHoleFeatureSchema = z.object({
  type: z.literal("Hole") satisfies z.ZodType<VisibleFeatureType>,
  subType: z.literal("hole_complex"),
  count: z.number(),
  edgeLength: z.number(),
});

export const foldedHoleFeatureSchema = z.object({
  type: z.literal("Hole") satisfies z.ZodType<VisibleFeatureType>,
  subType: z.literal("hole_folded"),
  count: z.number(),
  edgeLength: z.number(),
});

export const foldFeatureSchema = z.object({
  type: z.literal("Folding") satisfies z.ZodType<VisibleFeatureType>,
  count: z.number(),
  angle: z.number().nullable(),
});

export const sideFeatureSchema = z.object({
  type: z.literal("Side") satisfies z.ZodType<VisibleFeatureType>,
  count: z.number(),
  length: z.number(),
});

export const FormatedFeatureSchema = z.union([
  circularHoleFeatureSchema,
  slottedHoleFeatureSchema,
  complexHoleFeatureSchema,
  foldedHoleFeatureSchema,
  foldFeatureSchema,
  sideFeatureSchema,
]);

export type FormatedFeatureType = z.infer<typeof FormatedFeatureSchema>;

export const isFeatureVisible = (type: string): type is VisibleFeatureType =>
  (visibleFeatureTypes as readonly string[]).includes(type);
